var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-box"},[_c('div',{staticClass:"card-icon"},[_c('img',{attrs:{"src":"assets/images/icons/"+_vm.feature.icon+".png"}})]),_c('div',{staticClass:"card-content"},[_vm._v(" "+_vm._s(_vm.feature.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }